import useMutation from '@pkg/graphql/useMutation';

const CREATE_NEW_ACCOUNT = /* GraphQL */ `
  mutation CreateNewAccount($input: CreateNewAccountInput!) {
    createNewAccount(input: $input) {
      tenant_id
    }
  }
`;

/**
 * @param {any[]} query
 */
export default function useCreateAccount(query) {
  const { mutateAsync } = useMutation({
    mutation: CREATE_NEW_ACCOUNT,
    invalidateQuery: query,
  });

  /**
   * @param {Object} input
   * @param {String} input.name
   * @param {String} input.user_id
   * @returns {Object}
   */
  const createAccount = (input) => {
    return mutateAsync({ ...input });
  };

  return createAccount;
}
